import { API_BASE_URL } from "@/env.js";
import { HTTPError } from "./httpError";
import { LOGIN_PATH } from "../env";
import { getAuth } from "firebase/auth";
import { Firebase_App } from "../firebase";

export async function getBearerToken() {
  const auth = getAuth(Firebase_App);

  const user = auth.currentUser

  if (!user) {
    loginFallback();
  }

  const token = await user.getIdToken()

  if (!token) {
    loginFallback();
  }

  return token

}

function loginFallback() {
  window.location = LOGIN_PATH;
  throw '401';
}

export async function call(method, path, payload) {
  const token = await getBearerToken()
  const params = {
    method,   
    headers: {
      'Authorization': `Bearer ${token}`,      
    }
  }

  const multipart = payload instanceof FormData;

  if (payload) {
    params.body = multipart ? payload : JSON.stringify(payload);
    if (!multipart) {
      params.headers['Content-Type'] = 'application/json';
    }
  }

  const response = await fetch(API_BASE_URL + path, params);
  
  if (response.status === 401) {
    loginFallback()
  }

  if (!response.ok) {
    let details = null;
    try {
      details = await response.text()
    } catch {}
    throw new HTTPError("Error calling " + path, response.status, details);
  }

  const contentType = response.headers.get('content-type');

  if (contentType?.toLowerCase().includes('application/json')) {
    return await response.json();
  } else {
    return await response.text();    
  }
}

async function stream(path, payload) {
  const token = await getBearerToken()
  const params = {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }

  if (payload) {
    params.body = JSON.stringify({});
  }

  const response = await fetch(path, params);
  
  if (response.status === 401) {
    loginFallback()
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let done = false;
  let text = '';

  // Read the stream as it comes in
  while (!done) {
    const { value, done: doneReading } = await reader.read();
    done = doneReading;
    text = decoder.decode(value, { stream: true });

    // Log the latest token in the text stream
    console.log(text);
  }
}

window.a2t_stream = stream;
window.a2t_call = call;